
export const isNotNullorUndefined = (variable) => {
    if (variable !== null && variable !== undefined) {
        return true;
    }
    return false;

};